var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTripTimeDu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Location on",
    clipPath: "url(#clip0_12147_10332)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.668 11.0078V19.0088L18.9354 22.876L20.0022 21.2758L14.6682 18.0754V11.0078H12.668Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.2293 16.3321C23.296 16.7721 23.336 17.2122 23.336 17.6656C23.336 22.8662 19.2022 27.0001 14.0015 27.0001C8.80085 27.0001 4.667 22.8662 4.667 17.6656C4.667 12.4649 8.80085 8.33106 14.0015 8.33106C14.9349 8.33106 15.8284 8.46441 16.6685 8.71778V5.97077C15.8151 5.77074 14.9216 5.66406 14.0015 5.66406C7.334 5.66406 2 10.9981 2 17.6656C2 24.3331 7.334 29.6671 14.0015 29.6671C20.669 29.6671 26.003 24.3331 26.003 17.6656C26.003 17.2122 25.9763 16.7721 25.923 16.3321H23.2293Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M26.0034 7.0005V3H23.3364V7.0005H19.3359V9.6675H23.3364V13.668H26.0034V9.6675H30.0039V7.0005H26.0034Z",
    fill: "black"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12147_10332"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTripTimeDu);
export default __webpack_public_path__ + "static/media/TripTimeDU.082082d1.svg";
export { ForwardRef as ReactComponent };